import { render, staticRenderFns } from "./SalesServices.vue?vue&type=template&id=50b91847&scoped=true&"
import script from "./SalesServices.vue?vue&type=script&lang=js&"
export * from "./SalesServices.vue?vue&type=script&lang=js&"
import style0 from "./SalesServices.vue?vue&type=style&index=0&id=50b91847&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b91847",
  null
  
)

export default component.exports